import React from 'react'
import styled from 'styled-components'
import Grid from '@mui/material/Grid2'
import FleetLogoFullColor from 'core-system/FleetLogos/FleetLogoFullColor'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import pxToRem from 'core-system/utils/pxToRem'
import { userActions } from 'redux/user/userSlice'
import { OnboardingStage } from '../onboardingSlice'
import { useDispatch } from 'react-redux'

const LogoContainer = styled.div`
  top: 3rem;
  padding-bottom: 3rem;
  left: 3rem;
`

const MainContainer = styled(Grid)`
  height: 100vh;
`

const LeftContainer = styled(Grid)`
  padding: 2.5rem 4rem;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.palette.white};
`

const RightContainer = styled(Grid)`
  display: flex;
  align-items: center;
  flex-direction: column;
`

const BottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: center;
  align-items: center;
  align-content: center;
  margin-top: auto;
  width: 100%;
  justify-content: right;
  padding-block: 1.5rem;
`

const StyledLink = styled(Text)`
  color: ${(props) => props.theme.palette.secondary.purple600};
  text-decoration: underline;
  margin-top: 0;
  margin-bottom: 0;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.palette.text.primary};
  }
`

const NavFooter = styled.div`
  display: flex;
  align-self: center;
  width: 100%;
  justify-content: right;
`

const PageIndicators = styled.div`
  display: flex;
  gap: ${pxToRem(8)};
  justify-content: center;
  align-items: center;
  align-self: center;
`

const Page = styled.div<{ isActive: boolean }>`
  border-radius: 50%;
  width: ${pxToRem(12)};
  height: ${pxToRem(12)};
  background-color: ${(props) =>
    props.isActive
      ? props.theme.palette.primary.pink800
      : props.theme.palette.grey.grey300};
`

interface PageWrapperProps {
  leftContent: React.ReactNode
  rightContent: React.ReactNode
  title: string
  showBottomContainer: boolean
  onboardingStage: OnboardingStage
}

const PageWrapper = React.memo(
  ({
    leftContent,
    rightContent,
    title,
    showBottomContainer,
    onboardingStage,
  }: PageWrapperProps) => {
    const dispatch = useDispatch()

    return (
      <MainContainer container>
        <LeftContainer size={{ xs: 12, sm: 12, md: 6 }}>
          <LogoContainer>
            <FleetLogoFullColor height='40' width='190' />
          </LogoContainer>
          <Text variant='h1' color='black' marginBottom='1.5rem'>
            {title}
          </Text>
          {leftContent}
          {showBottomContainer && (
            <BottomContainer>
              <Text
                variant='action2'
                style={{
                  display: 'flex',
                  whiteSpace: 'nowrap',
                }}
                textColor={palette.black}
              >
                <StyledLink
                  variant='action2'
                  onClick={() => dispatch(userActions.logout())}
                >
                  Log out
                </StyledLink>
                &nbsp;
                {onboardingStage !== 'SUCCESS' && 'and complete later'}
              </Text>
              <NavFooter>
                {onboardingStage !== 'SUCCESS' && (
                  <PageIndicators>
                    <Page isActive={onboardingStage === 'WORKFORCE_SYNC'} />
                    <Page isActive={onboardingStage === 'STRIPE_SYNC'} />
                  </PageIndicators>
                )}
              </NavFooter>
            </BottomContainer>
          )}
        </LeftContainer>
        <RightContainer size={{ xs: 12, sm: 12, md: 6 }}>
          {rightContent}
        </RightContainer>
      </MainContainer>
    )
  }
)

export default PageWrapper
